import React, { useEffect, useRef, useState } from 'react';
import SliderSlick from 'react-slick';
import { FiMapPin } from 'react-icons/fi';
import { TbArrowUpRight } from 'react-icons/tb';
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';

import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Container,
  Hero,
  Services,
  OurClinic,
  SpeedConsultation,
  SpecialTreatments,
  Benefits,
  Location,
  CoiKids,
  Testimonials,
  Avatar,
} from './styles';

import logo from '~/assets/logos/full-logo.svg';
import draIvani from '~/assets/defaults/dra-ivani-welcome.png';
import front from '~/assets/defaults/front.png';
import frontMobile from '~/assets/defaults/front-mobile.png';
import xRay from '~/assets/defaults/x-ray.png';
import sterilizationCenter from '~/assets/defaults/sterilization-center.png';
import technologicalTreatments from '~/assets/defaults/technological-treatments.png';
import personalizedTreatments from '~/assets/defaults/personalized-treatments.png';
import coiExpirience from '~/assets/defaults/coi-expirience.png';
import coiExpirienceLaptop from '~/assets/defaults/coi-expirience-laptop.png';
import coiExpirienceMobile from '~/assets/defaults/coi-expirience-mobile.png';
import checkUp from '~/assets/defaults/check-up.png';
import checkUpLaptop from '~/assets/defaults/check-up-laptop.png';
import checkUpMobile from '~/assets/defaults/check-up-mobile.png';
import stamp from '~/assets/defaults/stamp.png';
import dayclinic from '~/assets/icons/dayclinic.svg';
import preventiveTreatments from '~/assets/icons/preventive-treatments.svg';
import invisalign from '~/assets/icons/invisalign.svg';
import pediatricDentistry from '~/assets/icons/pediatric-dentistry.svg';
import endodontic from '~/assets/icons/endodontic.svg';
import orofacialHarmonization from '~/assets/icons/orofacial-harmonization.svg';
import oralAesthetics from '~/assets/icons/oral-aesthetics.svg';
import implantsDental from '~/assets/icons/implants-dental.svg';
import periodontics from '~/assets/icons/periodontics.svg';
import prosthesis from '~/assets/icons/prosthesis.svg';
import dentistry from '~/assets/icons/dentistry.svg';
import checkUpIcon from '~/assets/icons/check-up.svg';
import benefits from '~/assets/defaults/benefits.png';
import locationBig from '~/assets/defaults/location-big.png';
import locationMobile from '~/assets/defaults/location.png';
import kids from '~/assets/defaults/kids.svg';
import Logo from '~/assets/logos/Logo';
import kidsWaitingRoom from '~/assets/defaults/kids-waiting-room.png';
import kidsWaitingRoomMobile from '~/assets/defaults/kids-waiting-room-mobile.png';
import drawTable from '~/assets/defaults/draw-table.png';
import drawTableMobile from '~/assets/defaults/draw-table-mobile.png';
import kidsDentistConsutory from '~/assets/defaults/kids-dentist-consutory.png';
import kidsDentistConsutoryMobile from '~/assets/defaults/kids-dentist-consutory-mobile.png';
import avatar1 from '~/assets/defaults/avatar-1.png';
import avatar2 from '~/assets/defaults/avatar-2.png';
import avatar3 from '~/assets/defaults/avatar-3.png';
import avatar4 from '~/assets/defaults/avatar-4.png';
import whatsAppSVG from '~/assets/icons/whatsapp.svg';

interface ITestimony {
  id: number;
  avatar: string;
  name: string;
  content: string;
}

const Welcome: React.FC = () => {
  const location = useLocation();
  const kidsSlideRef = useRef<SliderSlick>(null);
  const testmoniesSlideRef = useRef<SliderSlick>(null);
  const [testimonies] = useState<ITestimony[]>([
    {
      id: 1,
      avatar: avatar1,
      name: 'Ivonete',
      content:
        'A felicidade é o sorriso que está bem embaixo do nosso nariz!, valeu cada centavo. E vc é a responsável por esta felicidade! Vc é incrível!',
    },
    {
      id: 2,
      avatar: avatar2,
      name: 'Tamires',
      content:
        'Não tenho palavras para agradecer a você Dra Ivani, uma pessoa que dedica seu tempo e vida ao próximo, isso é um dom extraordinário.',
    },
    {
      id: 3,
      avatar: avatar3,
      name: 'Daniela',
      content:
        'Com o tratamento, ganhei a satisfação de poder distribuir sem economia um sorriso lindo e harmonioso. Sinceramente. ando rindo atoa.',
    },
    {
      id: 4,
      avatar: avatar4,
      name: 'Gabriela',
      content:
        'Sempre fico impressionada com estrutura da COI, tecnologia de ponta, os melhores cuidados, super atenciosos, tanto que indiquei minha família.',
    },
  ]);
  const [opened, setOpened] = useState(false);
  const [whatsappMessage, setWhatsappMessage] = useState('');

  useEffect(() => {
    if (location.pathname.includes('rede-social')) {
      setWhatsappMessage(
        'Olá! Encontrei vocês nas redes sociais e estou interessado em marcar um horário.'
      );
    } else {
      setWhatsappMessage('Olá gostaria de agendar uma consulta');
    }
  }, [location.pathname]);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Dentist',
      name: 'COI Prime Odontologia',
      description:
        'Clínica odontológica em Barueri especializada em clareamento dental, tratamento de canal, implantes dentários, harmonização orofacial, odontopediatria, alinhadores transparentes Invisalign, próteses dentárias e check-up odontológico com raio-x panorâmico.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Av. Trindade, 165, Bethaville I',
        addressLocality: 'Barueri',
        addressRegion: 'SP',
        postalCode: '06404-326',
        addressCountry: 'BR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: -23.5122,
        longitude: -46.8761,
      },
      telephone: '+551141981987',
      openingHours: 'Mo-Fr 08:00-18:00',
      url: 'https://www.coiprime.com.br',
      image: 'https://www.coiprime.com.br/favicon-96x96.png',
      sameAs: [
        'https://www.instagram.com/coiprime',
        'https://maps.app.goo.gl/FEp8zLwU43friSKN6',
      ],
      offers: [
        {
          '@type': 'Offer',
          name: 'Clareamento Dental',
          description:
            'Clareamento dental em Barueri com tecnologia avançada para um sorriso mais branco.',
          url: 'https://www.coiprime.com.br/estetica',
        },
        {
          '@type': 'Offer',
          name: 'Tratamento de Canal',
          description:
            'Tratamento de canal em Barueri para alívio de dor de dente e dente inflamado.',
          url: 'https://www.coiprime.com.br/implantes',
        },
        {
          '@type': 'Offer',
          name: 'Implante Dentário',
          description:
            'Implantes dentários em Barueri - Bethaville para substituir dentes perdidos com especialistas.',
          url: 'https://www.coiprime.com.br/implantes',
        },
        {
          '@type': 'Offer',
          name: 'Check-up Odontológico',
          description:
            'Check-up odontológico com raio-x panorâmico e limpeza dental em Barueri.',
          url: 'https://www.coiprime.com.br/bem-vindos',
        },
        {
          '@type': 'Offer',
          name: 'Prótese Dentária',
          description:
            'Próteses dentárias em Barueri para substituir dentes perdidos.',
          url: 'https://www.coiprime.com.br/implantes',
        },
        {
          '@type': 'Offer',
          name: 'Harmonização Orofacial',
          description:
            'Harmonização orofacial em Barueri com aplicação de botox para rugas de expressão.',
          url: 'https://www.coiprime.com.br/estetica',
        },
        {
          '@type': 'Offer',
          name: 'Odontopediatria',
          description:
            'Tratamentos odontopediátricos em Barueri, incluindo flúor e aparelhos para crianças.',
          url: 'https://www.coiprime.com.br/bem-vindos',
        },
        {
          '@type': 'Offer',
          name: 'Alinhadores Transparentes',
          description:
            'Alinhadores transparentes Invisalign em Barueri para alinhar dentes sem aparelho fixo.',
          url: 'https://www.coiprime.com.br/estetica',
        },
      ],
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return (
    <Container>
      <Helmet>
        <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
        <link rel="canonical" href="https://coiprime.com.br" />
        <meta
          name="description"
          content="COI Prime Odontologia em Barueri oferece clareamento dental, tratamento de canal, implantes dentários, harmonização orofacial, odontopediatria, alinhadores transparentes Invisalign, próteses dentárias e check-up odontológico com raio-x panorâmico."
        />
        <meta
          name="keywords"
          content="clareamento Barueri, clareamento dental preço, dor de dente tratamento, dente inflamado o que fazer, preço tratamento de canal, dentista tratamento de canal em Barueri, agendar tratamento de canal, falta de dente o que fazer, como funciona implante dentário, valor implante dentário em Barueri, implante dentário em Barueri, clínica de implantes em Barueri, dentista especialista em implante dentário, avaliação para implante dentário, limpeza de dente com dentista, valor limpeza dental Barueri, check-up odontológico com raio-x panorâmico, falta de dentes causa problemas, como substituir dentes perdidos, prótese dentária o que é, prótese dentária em Barueri, agendar consulta prótese dentária, especialista em prótese dentária perto de mim, harmonização orofacial em Barueri, botox antes e depois, botox para rugas de expressão, aplicação de botox em Barueri, especialista em botox facial em Barueri, primeira consulta odontopediatria, odontopediatria em Barueri, clínica odontopediatria infantil, preço de consulta com dentista infantil, tratamentos dentários para crianças, flúor para crianças no dentista, aparelho infantil para dentes tortos, agendar consulta dentista infantil, odontopediatria com RX panorâmico e limpeza, aparelho transparente, aparelho invisível, como alinhar os dentes sem aparelho fixo, clínica alinhadores transparentes Barueri, onde colocar aparelho invisível Barueri, dentista especialista em alinhadores, Invisalign Barueri preço, agendar consulta aparelho transparente"
        />
        <meta name="robots" content="index, follow" />
        <title>
          COI Prime - Atendimento odontológico exclusivo e personalizado.
        </title>
      </Helmet>
      <Hero className="position-relative">
        <div className="container h-100 position-relative">
          <div className="row align-items-lg-center h-100">
            <div className="col-lg-7 order-1 order-lg-0 text-center text-lg-start">
              <h1 className="text-white fw-light d-flex flex-column h2 display-lg-4 display-xxl-3 text-center text-lg-start">
                <span className="h3 h1-lg fw-medium">COI Prime</span>
                Referência em
                <span className="fw-semibold">
                  Clareamento Dental, Implantes e Harmonização Orofacial
                </span>{' '}
                em Barueri
              </h1>
              <p className="h5 h3-lg text-white text-center text-lg-start mt-5 mt-lg-0">
                Transforme seu sorriso com clareamento dental,{' '}
                <br className="d-none d-lg-block" />
                implantes dentários e harmonização orofacial em
                Barueri/Bethaville. Agende na COI Prime!
              </p>
              <div className="d-lg-flex flex-column align-items-start w-100 w-lg-75">
                <a
                  href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="mt-5 btn btn-schedule rounded-pill text-white fs-5 fs-lg-4 fw-medium px-5 py-3"
                  title="Agende já sua consulta particular"
                >
                  Agende já sua consulta particular{' '}
                  <img
                    loading="lazy"
                    src={whatsAppSVG}
                    width={24}
                    alt="whatsapp"
                  />
                </a>
                <small className="d-block text-white mt-2 fs-6 w-100">
                  *Não atendemos convênios e Planos&nbsp;de&nbsp;Saúde
                </small>
              </div>
            </div>
            <div className="col-lg-5 align-self-start d-flex justify-content-center justify-content-lg-end pt-5 order-0 order-lg-1">
              <img loading="lazy" src={logo} alt="logo" />
            </div>
          </div>
        </div>
        <div className="position-absolute d-none d-lg-flex dra-ivani">
          <img loading="lazy" src={draIvani} alt="Dra. Ivani - CRO 66115" />
          <p>
            Dra Ivani
            <br />
            CRO 66115
          </p>
        </div>
      </Hero>
      <Services>
        <div className="container">
          <div className="row py-5 px-3 px-lg-0">
            <div className="col-12 bg-gray px-3 py-5 px-lg-5">
              <div className="row justify-content-between align-items-center px-3 px-lg-5">
                <div className="col-7 col-lg-6 col-xl-5">
                  <h2 className="fs-2 fs-lg-1 fw-medium mb-0">
                    Nossos principais serviços odontológicos
                  </h2>
                </div>
                <div className="col-5 col-lg-6 mt-n5 mt-lg-0">
                  <img
                    loading="lazy"
                    src={stamp}
                    alt="Clínica odontológica mais tecnológica de Barueri"
                    className="d-block ms-auto stamp mt-lg-0 mt-xl-n4 w-100 w-lg-50 w-xl-auto"
                  />
                </div>
                <div className="col-lg-10 mt-4 mt-xl-n4">
                  <p className="fw-light fs-lg-5 text-black">
                    Descubra serviços especializados como clareamento dental,
                    tratamento de canal, implantes dentários, harmonização
                    orofacial, odontopediatria, alinhadores transparentes
                    Invisalign, próteses dentárias e check-up odontológico com
                    raio-x panorâmico em Barueri.
                  </p>
                </div>
              </div>
              <div
                className={`row mt-5 px-3 px-lg-5 trataments ${
                  opened ? 'opened' : ''
                }`}
              >
                <div className="col-md-6 col-lg-3">
                  <img
                    loading="lazy"
                    src={dayclinic}
                    alt="COI Experience Dayclinic em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    COI Experience <br />
                    Dayclinic
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5 mt-md-0">
                  <img
                    loading="lazy"
                    src={preventiveTreatments}
                    alt="Tratamentos preventivos odontológicos"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Tratamentos <br />
                    Preventivos
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5 mt-lg-0">
                  <img
                    loading="lazy"
                    src={invisalign}
                    alt="Alinhadores transparentes Invisalign em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Alinhadores <br />
                    Transparentes
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5 mt-lg-0">
                  <img
                    loading="lazy"
                    src={pediatricDentistry}
                    alt="Odontopediatria em Barueri para crianças"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Odontopediatria
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={endodontic}
                    alt="Tratamento de canal em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Tratamento de <br />
                    Canal
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={orofacialHarmonization}
                    alt="Harmonização orofacial com botox em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Harmonização <br />
                    Orofacial
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={oralAesthetics}
                    alt="Clareamento dental em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Clareamento <br />
                    Dental
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={implantsDental}
                    alt="Implantes dentários em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Implantes <br />
                    Dentários
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={periodontics}
                    alt="Periodontia em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Periodontia
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={prosthesis}
                    alt="Prótese dentária em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Prótese <br />
                    Dentária
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={dentistry}
                    alt="Odontologia geral em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Odontologia
                  </h3>
                </div>
                <div className="col-md-6 col-lg-3 mt-5">
                  <img
                    loading="lazy"
                    src={checkUpIcon}
                    alt="Check-up odontológico com raio-x panorâmico em Barueri"
                  />
                  <h3 className="mb-0 fs-5 fw-medium mt-4 text-black">
                    Check-up <br />
                    Preventivo
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-4">
                  <button
                    type="button"
                    className="fs-5 fs-lg-4 fw-medium text-center w-100 d-block mt-5 mb-4 text-black border-0 bg-transparent"
                    title="Ver todos os serviços odontológicos"
                    onClick={() => setOpened((state) => !state)}
                  >
                    {opened ? 'Ver menos' : 'Ver todos os serviços'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Services>
      <OurClinic>
        <div className="container py-5 my-5">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6 col-xl-4">
              <div>
                <h2 className="h2 display-lg-4 fw-medium mb-5 text-black">
                  Conheça nossa clínica em Barueri
                </h2>
                <div className="d-block d-lg-none position-relative mb-5">
                  <img
                    loading="lazy"
                    src={front}
                    alt="Fachada da COI Prime Odontologia em Barueri à noite, com letreiro iluminado"
                    className="w-100 front-mobile front-sm d-none d-sm-block"
                  />
                  <img
                    loading="lazy"
                    src={frontMobile}
                    alt="Fachada da COI Prime Odontologia em Barueri à noite, com letreiro iluminado"
                    className="w-100 front-mobile d-block d-sm-none"
                  />
                  <div className="d-flex box-group">
                    <div className="brown-box p-3 p-lg-4 me-4">
                      <p className="mb-0 small normal-lg">Pacientes</p>
                      <p className="fs-5 fs-lg-3 mb-0 my-lg-2">
                        <b>+ 8 mil</b>
                      </p>
                      <p className="mb-0 small normal-lg">Atendidos</p>
                    </div>
                    <div className="black-box p-3 p-lg-4">
                      <p className="mb-0 small normal-lg">Doutores</p>
                      <p className="fs-5 fs-lg-3 mb-0 my-lg-2">
                        <b>09</b>
                      </p>
                      <p className="mb-0 small normal-lg">
                        Especialistas em odontologia
                      </p>
                    </div>
                  </div>
                </div>
                <p className="content">
                  Estrutura de 650m² dedicada à odontologia em Barueri,
                  oferecendo clareamento dental, implantes dentários,
                  harmonização orofacial e mais.
                </p>
                <p className="content">
                  Com 8 consultórios, 4 salas de espera, espaço kids, elevador,
                  acessibilidade e estacionamento no subsolo.
                </p>
                <div className="location rounded-pill px-4 py-2 d-flex align-items-center justify-content-center">
                  <FiMapPin size={30} color="#BE7E38" className="me-2" />
                  <p className="mb-0 fw-medium">Bethaville, Barueri</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-8 d-none d-lg-block">
              <div className="position-relative">
                <img
                  src={front}
                  alt="Fachada da COI Prime Odontologia em Barueri à noite, com letreiro iluminado"
                  className="d-block ms-lg-auto w-100 w-xl-auto"
                />
                <div className="d-flex box-group">
                  <div className="brown-box p-3 p-lg-4 me-4">
                    <p className="mb-0 small normal-lg">Pacientes</p>
                    <p className="fs-5 fs-lg-3 mb-0 my-lg-2">
                      <b>+ 8 mil</b>
                    </p>
                    <p className="mb-0 small normal-lg">Atendidos</p>
                  </div>
                  <div className="black-box p-3 p-lg-4">
                    <p className="mb-0 small normal-lg">Doutores</p>
                    <p className="fs-5 fs-lg-3 mb-0 my-lg-2">
                      <b>09</b>
                    </p>
                    <p className="mb-0 small normal-lg">
                      Especialistas em odontologia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </OurClinic>
      <SpeedConsultation>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bg-gray">
                <p>Agilidade em sua consulta odontológica</p>
                <h2 className="h5 h3-lg">
                  Atendimento Prime com <b>alta tecnologia</b> para{' '}
                  <br className="d-none d-lg-block" />
                  clareamento dental, tratamento de canal e implantes
                </h2>
                <p className="fw-light mb-4">
                  Especialistas em Barueri comprometidos com tratamentos como
                  clareamento dental, implantes dentários, harmonização
                  orofacial e odontopediatria, utilizando tecnologia avançada.
                </p>
                <p className="fw-light mb-0">
                  A escolha número um em Barueri para transformar sorrisos!
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img
                src={xRay}
                alt="Raio-x panorâmico para check-up odontológico em Barueri"
              />
              <p className="mb-5 mb-lg-0 mt-3 mt-lg-4 text-center">
                Raio-x <br />
                Panorâmico
              </p>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img
                src={sterilizationCenter}
                alt="Centro de esterilização odontológica"
              />
              <p className="mb-5 mb-lg-0 mt-3 mt-lg-4 text-center">
                Centro de <br />
                Esterilização
              </p>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img
                src={technologicalTreatments}
                alt="Tratamentos odontológicos tecnológicos em Barueri"
              />
              <p className="mb-0 mt-3 mt-lg-4 text-center">
                Tratamentos <br />
                Tecnológicos
              </p>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img
                src={personalizedTreatments}
                alt="Tratamentos odontológicos personalizados"
              />
              <p className="mb-0 mt-3 mt-lg-4 text-center">
                Tratamentos <br />
                Personalizados
              </p>
            </div>
          </div>
        </div>
      </SpeedConsultation>
      <Benefits>
        <div className="container py-5 my-5">
          <div className="row align-items-center">
            <div className="col-lg-6 order-1 order-lg-0">
              <h2 className="h2 h1-lg mb-5 text-black">
                Benefícios Exclusivos na COI Prime Barueri
              </h2>
              <div className="w-xl-75">
                <p className="fs-5 mb-4">
                  Acesse o melhor em odontologia com clareamento dental,
                  implantes dentários, harmonização orofacial e alinhadores
                  Invisalign em Barueri.
                </p>
                <p className="fs-5 mb-5">
                  Priorizamos sua saúde bucal com tecnologia de ponta e
                  experiência excepcional.
                </p>
              </div>
              <div className="d-lg-flex flex-column align-items-center w-100 w-lg-75">
                <a
                  href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="btn btn-primary rounded-pill py-3 fs-5 fw-medium w-100"
                  title="Agende sua consulta para clareamento ou implante dentário"
                >
                  Agende sua consulta particular{' '}
                  <img
                    loading="lazy"
                    src={whatsAppSVG}
                    width={24}
                    alt="WhatsApp para agendamento"
                  />
                </a>
                <small className="d-block mt-2 fs-6 text-center w-100">
                  *Não atendemos convênios e Planos de Saúde
                </small>
              </div>
            </div>
            <div className="col-lg-6 order-0 order-lg-1 mb-5 mb-lg-0">
              <img
                src={benefits}
                alt="Consultório odontológico em Barueri com tecnologia de ponta"
                className="w-100 w-md-75 w-lg-100 d-block mx-md-auto mx-lg-0"
              />
            </div>
          </div>
        </div>
      </Benefits>
      <Location>
        <div className="container py-5 my-5">
          <div className="row">
            <div className="col-12">
              <div className="bg-gray-mobile">
                <div className="row justify-content-between align-items-center align-items-xxl-end">
                  <div className="col-lg-5 mb-5 mb-lg-0 pe-lg-0 position-relative">
                    <img
                      loading="lazy"
                      src={locationBig}
                      alt="Fachada da COI Prime Odontologia em Barueri à noite"
                      className="w-100 w-md-75 w-lg-100 d-block d-lg-none d-xl-block mx-md-auto mx-lg-0"
                    />
                    <img
                      loading="lazy"
                      src={locationMobile}
                      alt="Fachada da COI Prime Odontologia em Barueri à noite"
                      className="w-100 w-md-75 w-lg-100 d-none d-lg-block d-xl-none mx-md-auto mx-lg-0"
                    />
                    <div className="detail" />
                  </div>
                  <div className="col-lg-7 bg-gray">
                    <div>
                      <h3 className="h6 h5-lg fw-light text-black">
                        LOCALIZAÇÃO
                      </h3>
                      <h2 className="h2 h1-lg mb-5 text-black">
                        Clínica odontológica em Barueri
                      </h2>
                    </div>
                    <div className="d-flex align-items-lg-center mb-4">
                      <FiMapPin size={30} color="#BE7E38" />
                      <div className="ms-2">
                        <h3 className="fs-6 fw-normal mb-0">Endereço:</h3>
                        <p className="mb-0">
                          Av. Trindade, 165 – Bethaville I, Barueri – SP,
                          06404-326
                        </p>
                      </div>
                    </div>
                    <ul className="ps-lg-5 ms-lg-3 mb-5">
                      <li className="text-secondary">
                        <p className="mb-0">
                          Fácil acesso pela Rodovia Castelo Branco
                        </p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">Elevador de acessos</p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">Estacionamento próprio</p>
                      </li>
                    </ul>
                    <a
                      href="https://maps.app.goo.gl/FEp8zLwU43friSKN6"
                      rel="noopener noreferrer"
                      target="_blank"
                      className="btn btn-black rounded-pill px-4 py-2 fw-medium ms-2 ms-lg-0"
                      title="Ver rotas para COI Prime em Barueri"
                    >
                      Ver rotas{' '}
                      <TbArrowUpRight size={24} color="#fff" className="ms-2" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Location>
      <CoiKids>
        <div className="bg-gray">
          <div className="container pb-5">
            <div className="row">
              <div className="col-lg-12 d-flex flex-column">
                <div className="align-self-center mt-n5">
                  <div className="d-flex align-items-end logo mb-4">
                    <Logo color="#146392" className="me-2" />
                    <span className="text-start d-block fs-5 fw-light mb-0 logo-name">
                      Prime Odontologia
                    </span>
                  </div>
                  <img
                    loading="lazy"
                    src={kids}
                    alt="COI Prime Kids Odontopediatria em Barueri"
                    className="kids"
                  />
                </div>
                <div className="my-5">
                  <SliderSlick
                    ref={kidsSlideRef}
                    autoplay
                    autoplaySpeed={5000}
                    infinite
                  >
                    <div className="px-3">
                      <img
                        loading="lazy"
                        src={kidsWaitingRoom}
                        alt="Sala de espera infantil da COI Prime Kids em Barueri"
                        className="w-100 d-none d-lg-block"
                      />
                      <img
                        loading="lazy"
                        src={kidsWaitingRoomMobile}
                        alt="Sala de espera infantil da COI Prime Kids em Barueri"
                        className="w-100 d-block d-lg-none"
                      />
                    </div>
                    <div className="px-3">
                      <img
                        loading="lazy"
                        src={drawTable}
                        alt="Mesa de desenho para crianças na COI Prime Kids em Barueri"
                        className="w-100 d-none d-lg-block"
                      />
                      <img
                        loading="lazy"
                        src={drawTableMobile}
                        alt="Mesa de desenho para crianças na COI Prime Kids em Barueri"
                        className="w-100 d-block d-lg-none"
                      />
                    </div>
                    <div className="px-3">
                      <img
                        loading="lazy"
                        src={kidsDentistConsutory}
                        alt="Consultório odontopediátrico da COI Prime Kids em Barueri"
                        className="w-100 d-none d-lg-block"
                      />
                      <img
                        loading="lazy"
                        src={kidsDentistConsutoryMobile}
                        alt="Consultório odontopediátrico da COI Prime Kids em Barueri"
                        className="w-100 d-block d-lg-none"
                      />
                    </div>
                  </SliderSlick>
                  <div className="d-flex justify-content-end mt-3 px-5">
                    <button
                      type="button"
                      className="p-2 border-0 bg-transparent me-1"
                      onClick={() => {
                        kidsSlideRef.current?.slickPrev();
                      }}
                      title="Slide anterior"
                    >
                      <SlArrowLeft size={20} color="#000" />
                    </button>
                    <button
                      type="button"
                      className="p-2 border-0 bg-transparent ms-1"
                      onClick={() => {
                        kidsSlideRef.current?.slickNext();
                      }}
                      title="Próximo slide"
                    >
                      <SlArrowRight size={20} color="#000" />
                    </button>
                  </div>
                </div>
                <div className="px-3">
                  <p className="fs-5 fw-light mb-4">
                    Na COI Prime Kids, oferecemos odontopediatria em Barueri com
                    um ambiente lúdico para crianças, incluindo flúor e
                    aparelhos infantis.
                  </p>
                  <p className="fs-5 fw-light mb-4">
                    Profissionais dedicados garantem uma primeira consulta
                    odontopediátrica divertida e cuidadosa.
                  </p>
                  <p className="fs-5 fw-light mb-5">
                    Cuidado preventivo para crianças com raio-x panorâmico e
                    limpeza.
                  </p>
                </div>
                <a
                  href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="btn btn-orange px-5 py-3 rounded-pill fs-5 fw-medium align-self-start w-100 w-lg-auto"
                  title="Agende uma consulta odontopediátrica"
                >
                  Agende sua consulta infantil{' '}
                  <img
                    loading="lazy"
                    src={whatsAppSVG}
                    width={24}
                    alt="WhatsApp para agendamento"
                  />
                </a>
                <small className="mt-2 fs-6 ms-lg-4">
                  *Não atendemos convênios e Planos de Saúde
                </small>
              </div>
            </div>
          </div>
        </div>
      </CoiKids>
      <Testimonials>
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h2 className="h6 h5-lg fw-light mb-5">
                DEPOIMENTOS <br />
                <span className="h2 h1-lg fw-medium">Clientes COI Prime</span>
              </h2>
              <div>
                <SliderSlick
                  ref={testmoniesSlideRef}
                  slidesToShow={3}
                  autoplay
                  autoplaySpeed={10000}
                  infinite
                  arrows={false}
                  responsive={[
                    {
                      breakpoint: 991,
                      settings: {
                        slidesToShow: 2,
                      },
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 1,
                      },
                    },
                  ]}
                >
                  {testimonies.map((testimony) => (
                    <div key={testimony.id} className="p-3">
                      <div className="testimony p-4">
                        <div className="d-flex align-items-center mb-4">
                          <Avatar src={testimony.avatar} className="me-2" />
                          <p className="mb-0">{testimony.name}</p>
                        </div>
                        <p>{testimony.content}</p>
                      </div>
                    </div>
                  ))}
                </SliderSlick>
                <div className="d-flex justify-content-end mt-3 px-5">
                  <button
                    type="button"
                    className="p-2 border-0 btn-testmony-slide me-1"
                    onClick={() => {
                      testmoniesSlideRef.current?.slickPrev();
                    }}
                    title="Depoimento anterior"
                  >
                    <SlArrowLeft size={20} color="#000" />
                  </button>
                  <button
                    type="button"
                    className="p-2 border-0 btn-testmony-slide ms-1"
                    onClick={() => {
                      testmoniesSlideRef.current?.slickNext();
                    }}
                    title="Próximo depoimento"
                  >
                    <SlArrowRight size={20} color="#000" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Testimonials>
      <SpecialTreatments>
        <div className="container py-5">
          <SliderSlick
            infinite
            arrows={false}
            centerPadding="0px"
            autoplay
            autoplaySpeed={40000}
            dots
            adaptiveHeight
          >
            <div className="px-3">
              <div className="row bg-gray my-5">
                <div className="col-lg-5 px-0">
                  <img
                    loading="lazy"
                    src={coiExpirience}
                    alt="Equipe da COI Prime analisando raio-x panorâmico para tratamentos em Barueri"
                    className="w-100 d-none d-xl-block"
                  />
                  <img
                    loading="lazy"
                    src={coiExpirienceLaptop}
                    alt="Equipe da COI Prime analisando raio-x panorâmico para tratamentos em Barueri"
                    className="w-100 d-none d-lg-block d-xl-none"
                  />
                  <img
                    loading="lazy"
                    src={coiExpirienceMobile}
                    alt="Equipe da COI Prime analisando raio-x panorâmico para tratamentos em Barueri"
                    className="w-100 d-lg-none"
                  />
                </div>
                <div className="col-lg-7 px-3 py-5 px-lg-5 d-flex flex-column justify-content-between">
                  <div>
                    <h2 className="fs-4 fs-lg-1 fw-medium text-white">
                      COI Experience Dayclinic
                    </h2>
                    <p className="text-gray">
                      Para quem busca clareamento dental ou implantes dentários
                      em Barueri com rapidez
                    </p>
                  </div>
                  <div className="pe-lg-5 mt-4 mt-lg-0">
                    <p className="text-white mb-4">
                      Avaliação personalizada para clareamento dental,
                      tratamento de canal ou implantes dentários.
                    </p>
                    <p className="text-white mb-4">
                      No COI Experience Dayclinic, otimizamos seu tempo com
                      procedimentos ágeis em Barueri.
                    </p>
                    <p className="text-white mb-4">
                      Equipe com mais de 20 anos de experiência em odontologia,
                      oferecendo tratamentos seguros.
                    </p>
                    <p className="text-white">
                      Dayclinic completo para clareamento, implantes e
                      harmonização orofacial em Barueri.
                    </p>
                  </div>
                  <div className="d-lg-flex flex-column align-items-center w-100 w-lg-75">
                    <a
                      href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                      rel="noopener noreferrer"
                      target="_blank"
                      className="btn btn-primary rounded-pill py-3 fs-lg-5 fw-medium w-100 mt-4 mt-xl-0"
                      title="Agende seu Dayclinic em Barueri"
                    >
                      Agende seu Dayclinic
                    </a>
                    <small className="d-block text-white mt-2 fs-6 text-center w-100">
                      *Não atendemos convênios e Planos de Saúde
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row bg-gray my-5">
                <div className="col-lg-5 px-0">
                  <img
                    loading="lazy"
                    src={checkUp}
                    alt="Check-up odontológico com câmera intraoral em Barueri"
                    className="w-100 d-none d-xl-block"
                  />
                  <img
                    loading="lazy"
                    src={checkUpLaptop}
                    alt="Check-up odontológico com câmera intraoral em Barueri"
                    className="w-100 d-none d-lg-block d-xl-none"
                  />
                  <img
                    loading="lazy"
                    src={checkUpMobile}
                    alt="Check-up odontológico com câmera intraoral em Barueri"
                    className="w-100 d-lg-none"
                  />
                </div>
                <div className="col-lg-7 px-3 py-5 px-lg-5 d-flex flex-column justify-content-between">
                  <h2 className="fs-4 fs-lg-1 fw-medium text-white">
                    Check-up Digital com Raio-x Panorâmico
                  </h2>
                  <div className="pe-lg-5 mt-4 mt-xl-0">
                    <p className="text-white mb-4 mt-n3">
                      Check-up odontológico em Barueri:{' '}
                      <b>Prevenção e cuidado</b>
                    </p>
                    <p className="text-white mb-4">
                      Identificamos problemas bucais precocemente com raio-x
                      panorâmico e limpeza dental.
                    </p>
                    <div className="d-flex align-items-center">
                      <p className="text-white mb-0 tooth-content">
                        O check-up digital COI Prime previne complicações e
                        mantém sua saúde bucal.
                      </p>
                    </div>
                  </div>
                  <div className="d-lg-flex flex-column align-items-center w-100 w-lg-75">
                    <a
                      href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                      rel="noopener noreferrer"
                      target="_blank"
                      className="btn btn-primary rounded-pill py-3 fs-lg-5 fw-medium w-100 mt-4 mt-xl-0"
                      title="Agende seu check-up odontológico em Barueri"
                    >
                      Agende seu check-up
                    </a>
                    <small className="d-block text-white mt-2 fs-6 text-center w-100">
                      *Não atendemos convênios e Planos de Saúde
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </SliderSlick>
        </div>
      </SpecialTreatments>
    </Container>
  );
};

export default Welcome;
